<template>
  <div class="px-4">
    <v-row align="center">
      <v-col cols="12" sm="4" lg="3">
        <ValidationObserver ref="observer">
          <datepicker-cadu
            :menuOpen="menuOpen"
            :validateProviderRules="'required|yearAndMonthValidatorOnly3MonthsPast'"
            :inputTitle="'Aplicar competência'"
            :inputValue="dataCompetencia"
            :minDate="mesesPassados"
            :maxDate="today"
            placeholder="00/0000"
            @value="value => dataCompetencia = value"
            typeCalendar="month"
            width="280"
          ></datepicker-cadu>
        </ValidationObserver>
      </v-col>

      <v-col cols="12" sm="auto" class="mt-6">
        <button-cadu :width="190" :block="$vuetify.breakpoint.xs" iconName="refresh-cw" :iconSize="18" text="ATUALIZAR ONLINE" :loading="loadingAtualizar" @click="atualizarCompetenciaOnline"/>
      </v-col>

      <v-col>
        <v-row justify="end" class="mt-6">
          <v-col cols="12" sm="auto">
            <button-cadu :width="190" :block="$vuetify.breakpoint.xs" @click="showModalFiltrar = true">SELECIONAR UNIMEDS</button-cadu>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <table-cadu
          class="transacaoOnline mt-8"
          nameTab="TabelaTransacaoOnline"
          ref="tabelaTransacao"
          :disabledButtons="[]"
          :disabledAllButtons="disableButtons"
          custom
          :loading="isLoading"
          :rowsHeader="rowsHeader"
          :rows="rows"
          :showFiltro="false"
          :showSelect="false"
          :showCheck="false"
          :disabledCheckAll="true"
          @ordena="obj => changeOrdem(obj)"
        />
      </v-col>
    </v-row>
    <v-row justify="end" align="end" >
      <v-col cols="12" sm="auto">
        <button-cadu
          :width="190"
          text="REENVIAR COM ERRO"
          :block="$vuetify.breakpoint.xs"
          :loading="loadingErro"
          @click="reenviarUnimedComErro"
          :backColor="$vuetify.theme.themes.light.primary2"
        />
      </v-col>
    </v-row>

    <SucessoModal
      :genericMessage="'Processo Finalizado'"
      :showSucess="showSucesso"
      @close="closeSucesso"
    />

    <ModalFiltrarUnimed :value="showModalFiltrar" @input="value => showModalFiltrar = value" @filtrar="args => filtrar(args)"/>

    <error-modal v-model="error" :errObj="errObj" />
  </div>
</template>

<script>
import ModalFiltrarUnimed from './ModalFiltrarUnimeds'
import { ValidationObserver } from 'vee-validate'

import AtualizacaoBeneficiario from '../../../../../services/TransacaoOnline/AtualizacaoBeneficiario'
import moment from 'moment'

export default {
  components: {
    ModalFiltrarUnimed,
    ValidationObserver
  },

  data () {
    return {
      disableButtons: true,
      tokenBearer: localStorage.getItem('tokenBearer'),
      listaAplicacoes: [],
      aplicacaoSelecionada: '',

      isLoading: false,

      // Sucesso
      showSucesso: false,

      // Ordenacao Tabela
      ordemProp: 'desc',
      ordenacaoNome: 'versaoAtiva.codigo',

      // Modal
      showModalFiltrar: false,

      // Tabela
      rowsHeader: [
        { text: 'Código unimed', icon: 'repeat' },
        { text: 'Nome Fantasia' },
        { text: 'Competência' },
        { text: 'Status' }
      ],
      rows: [],
      filtroUnimeds: '',

      // DatePicker
      dataCompetencia: '',
      menuOpen: false,
      mesesPassados: moment().subtract(3, 'months').format('DD/MM/YYYY'),
      today: moment().subtract(1, 'months').format('DD/MM/YYYY'),

      // Erro
      error: false,
      errObj: {
        status: 'Status',
        error: 'Error'
      },
      loadingAtualizar: false,
      loadingErro: false
    }
  },

  async beforeMount () {
    this.carregarGetUnimeds()
  },

  methods: {
    async atualizarCompetenciaOnline () {
      let res = await this.$refs.observer.validate()
      if (res && !this.loadingErro) {
        this.loadingAtualizar = true
        const body = {
          competencia: this.dataCompetencia,
          codigosUnimeds: this.getUnimedCodigo(true)
        }
        await this.putAtualizarBeneficiario(body, true)
        this.loadingAtualizar = false
      }
    },

    // Irei reenviar somente os ID unimed que estão com a flag sucesso === false
    async reenviarUnimedComErro () {
      let res = await this.$refs.observer.validate()
      const unimedCodigo = this.getUnimedCodigo(false)
      let erroCount = 0

      this.rows.forEach((el) => ![undefined, null, true].includes(el.sucesso) ? erroCount++ : '')

      if (res && unimedCodigo.length > 0 && !this.loadingAtualizar && erroCount > 0) {
        this.loadingErro = true
        const body = {
          competencia: this.dataCompetencia,
          codigosUnimeds: unimedCodigo
        }
        await this.putAtualizarBeneficiario(body, false)
        this.loadingErro = false
        this.isLoading = false
      }
    },

    async filtrar (args) {
      this.filtroUnimeds = args
      this.carregarGetUnimeds()
    },

    async changeOrdem (obj) {
      this.ordemProp = this.ordemProp === 'asc' ? 'desc' : 'asc'
      const res = () => {
        switch (obj.index) {
          case 0:
            return 'versaoAtiva.codigo'
        }
      }
      this.ordenacaoNome = res()
      this.ordemProp = this.ordemProp
      this.carregarGetUnimeds()
    },

    async closeSucesso () {
      this.showSucesso = false
    },

    // Utils
    getUnimedCodigo (todasUnimed) {
      var array = []
      this.rows.forEach(unimedRow => {
        // Pegar todos ids unimeds ou somente os ids que tem flag de sucesso === false
        if (todasUnimed) {
          array.push(unimedRow.codigo)
        } else {
          if (!unimedRow.sucesso) {
            array.push(unimedRow.codigo)
          }
        }
      })
      return array
    },

    async mudarStatus (status, enviarParaTodos) {
      await this.$nextTick()
      /* eslint-disable */
      if (enviarParaTodos) await this.rows.map((el) => {
        el.status = (enviarParaTodos || !el.sucesso ? status : '')
        el.competencia = this.dataCompetencia
      })
      else this.rows.forEach((el) => {
        if (![undefined, null, true].includes(el.sucesso)) {
          el.status = (enviarParaTodos || !el.sucesso ? status : el.status)
          el.competencia = this.dataCompetencia
        }
      })
      this.$refs.tabelaTransacao.TabelaTransacaoOnline()
      this.$refs.tabelaTransacao.$forceUpdate()
    },

    // Insiro dentro do objeto o status e flag sucesso quando atualizo beneficiarios
    inserirDadosObjetoRows (listaUnimedPutAtualizar) {
      this.rows.forEach(unimedRow => {
        const findUnimedListaPutAtualizar = this.findUnimedPorCodigoUnimed(listaUnimedPutAtualizar, unimedRow.codigo)
        if (findUnimedListaPutAtualizar) {
          Object.assign(unimedRow, { status: findUnimedListaPutAtualizar.status, sucesso: findUnimedListaPutAtualizar.sucesso, competencia: this.dataCompetencia })
        }
      })
    },

    findUnimedPorCodigoUnimed (listaUnimed, codigoUnimed) {
      return listaUnimed.find(item => item.codigoUnimed === codigoUnimed)
    },

    reloadTabela () {
      setTimeout(() => {
        this.isLoading = false
      }, 100)
    },

    async carregarGetUnimeds () {
      this.isLoading = true
      await this.getAllUnimeds(this.getArg())
      this.isLoading = false
    },

    getArg () {
      return `${this.getArgumentosOrdenacao()}&${this.filtroUnimeds}`
    },

    getArgumentosOrdenacao () {
      let args = this.geradorParams(
        // ORDENAÇÃO
        {
          name: 'ordenacao',
          value: this.ordenacaoNome
        },
        {
          name: 'direcaoOrdenacao',
          value: this.ordemProp
        }
      )
      return args
    },

    geradorParams (...params) {
      let str = ''
      for (let p of params) {
        if (p.value) {
          str += `${p.name}=${p.value}&`
        }
      }
      if (params.length > 0) {
        str = str.substring(0, str.length - 1)
      }
      return str
    },

    // Requests
    async getAllUnimeds (args = '') {
      let listarUnimed = new AtualizacaoBeneficiario(
        this.tokenBearer,
        this.$appConfig.config.API
      )

      try {
        let response = await listarUnimed.getUnimeds(args)
        this.rows = response.data
      } catch (err) {
        this.isLoading = false
        this.error = true
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    },

    async putAtualizarBeneficiario (data, atualizarTodos) {
      this.mudarStatus('Aguardando', atualizarTodos)

      let atualizacao = new AtualizacaoBeneficiario(
        this.tokenBearer,
        this.$appConfig.config.API
      )

      try {
        let response = await atualizacao.putAtualizar(data)
        let unimed = response.data
        this.showSucesso = true
        this.inserirDadosObjetoRows(unimed)
        this.$refs.tabelaTransacao.TabelaTransacaoOnline()
        this.$refs.tabelaTransacao.$forceUpdate()
      } catch (err) {
        this.error = true
        this.mudarStatus('', true)
        this.errObj.status = err.response.status
        this.errObj.error = err.response.data.message
      }
    }
  },

  watch: {
    async dataCompetencia () {
      if (!this.dataCompetencia) {
        this.carregarGetUnimeds()
      }
    }
  }
}
</script>

<style lang="sass">
.transacaoOnline > .table-cadu
    border: none
    border-radius: 0px
    width: 100% !important
    padding-bottom: 4px
    padding: 0px !important

.transacaoOnline > .table-cadu > .table
  max-height: 250px
  overflow: auto
  table
    width: 100%
</style>
